import React, {Component} from 'react';
import Lottie from 'lottie-react-web';

import loading from '../../images/normalloading.json';

import {Modal} from '@material-ui/core';

class ModalLoading extends Component {
  render() {

  	const defaultOptions = {
	    loop: true,
	    autoplay: true, 
	    animationData: loading
	  };

  	return(
  		<Modal open style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
  			<div style={{borderRadius: "50%"}}>
	  			<Lottie
		        options={defaultOptions}
		        width="150px"
						height="150px"
		      />
	      </div>
  		</Modal>
  	);
  }
}
 
export default ModalLoading;